import React, { forwardRef, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  activeTabBgColor,
  colors,
  tabPillBackgroundColors,
  tabPillColors,
  vendorTabStyles,
  // investigationFirstTab,
} from "../../constants/colors";
import Typography from "@mui/material/Typography";
import propTypes from "prop-types";
import { ApprovalInvestigationMainTabs } from "../../constants/approvalsData";
import { Skeleton } from "@mui/material";
import { disableSecondTabVal } from "../../constants/caseManagementData";
import { useSelector } from "react-redux";
import { breakWordOnSpace } from "../../Utils/helper";

// variant pill, gray, grayShadow, standard
const MuiTab = forwardRef(
  (
    {
      indicatorColor = "#E7373B",
      onClick = () => {},
      variant = "pill",
      tabs = [],
      gap = "8px",
      activeTab = 0,
      setActiveTab = () => {},
      fontSize = "13px",
      padding = 1.5,
      popupType,
      type,
      breakLabel = false,
      customStyle = null,
      customTabSelectStyle = null,
      standardMinContent = false,
    },
    ref
  ) => {
    const [tabValue, setTabValue] = useState(activeTab || 0);
    const tabRef = useRef(null);
    const { searchSource, searchValue, searchType } = useSelector(
      (state) => state.SearchSlice
    );

    const handleChange = (event, newValue) => {
      if (
        searchSource === "Cima" &&
        disableSecondTabVal?.includes(event?.target?.innerText) &&
        searchValue &&
        searchType
      ) {
        return;
      }
      let invoiceStatus = event?.target?.dataset?.invoice_status;
      let investigationStatus = event?.target?.dataset?.investigation_status;
      setTabValue(newValue);
      setActiveTab(newValue);
      onClick(event, newValue, invoiceStatus, investigationStatus);
    };
    const getStyle = (index, item) => {
      // checking current tab name and according applying css using it
      const currentTabName =
        item?.label?.length && item?.label?.match(/[A-Za-z\s\W]+/)[0]?.trim();

      const variantTypes = {
        pill: {
          color: tabValue === index ? "white" : tabPillColors[currentTabName],
          backgroundColor:
            tabValue === index
              ? activeTabBgColor[currentTabName]
              : tabPillBackgroundColors[currentTabName],
          boxShadow:
            tabValue === index
              ? `0px 3px 10px 0px ${activeTabBgColor[currentTabName]}`
              : "none",
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: breakLabel ? "0.5rem 1.5rem" : 1.5,
          lineHeight: breakLabel ? 1.3 : 1.5,
          borderRadius: "4px",
        },
        standard: {
          color:
            tabValue === index
              ? item?.border
                ? "white"
                : indicatorColor
              : disableSecondTabVal?.includes(item?.label) &&
                  searchSource === "Cima" &&
                  searchValue &&
                  searchType
                ? "grey"
                : colors?.black,
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: 1,
          lineHeight: breakLabel ? 1.3 : 1.5,
          border: item?.border || "",
          borderRadius: item?.border ? "4px" : "",
          backgroundColor: tabValue === index ? item?.bg || "" : "",
        },
        gray: {
          color: tabValue === index ? indicatorColor : colors?.gray2,
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: "9px 12px 9px 12px !important",
          lineHeight: breakLabel ? 1.3 : 1.5,
          border:
            tabValue === index ? "1px solid #E8505B" : "1px solid #90949A",
          borderRadius: "4px",
        },
        grayShadow: {
          color: tabValue === index ? indicatorColor : "black",
          backgroundColor: tabValue === index ? "#FEF5F8" : "white",
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: breakLabel ? "0.5rem 1.5rem" : 1.5,
          lineHeight: breakLabel ? 1.3 : 1.5,
          border:
            tabValue === index ? "1px solid transparent" : "1px solid #90949A",
          borderRadius: "4px",
          boxShadow:
            tabValue === index ? "0px 2px 4px rgba(232, 80, 91, 0.5)" : "none",
        },
        boxed: {
          color: tabValue === index ? indicatorColor : colors?.black2,
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: 11,
          border:
            tabValue === index ? "1px solid #E8505B" : "1px solid #90949A",
          borderRadius: "4px",
        },
        customStyleTab: {
          color: tabValue === index ? indicatorColor : "black",
          backgroundColor:
            tabValue === index
              ? customTabSelectStyle
                ? customTabSelectStyle.backgroundColor
                : "#FEF5F8"
              : "white",
          boxShadow:
            tabValue === index
              ? customTabSelectStyle
                ? customTabSelectStyle.boxShadow
                : "0px 2px 4px rgba(232, 80, 91, 0.5)"
              : "none",
          border:
            tabValue === index ? "1px solid transparent" : "1px solid #90949A",
          fontWeight:
            tabValue === index
              ? customTabSelectStyle && customTabSelectStyle.fontWeight
              : "inherit",
          ...customStyle,
        },
      };
      return variantTypes[variant];
    };
    const getStyleTabIndicator = () => {
      let variantTypes = {
        pill: {
          backgroundColor: "transparent",
          width: 0,
          height: 0,
        },
        standard: {
          backgroundColor: indicatorColor,
          // height: tabs[0]?.label === "Investigation" && !tabValue ? 0 : 2,
          height: tabs[tabValue]?.label === "Investigation" ? 0 : 2,
          top: "57px",
        },
        gray: {
          backgroundColor: indicatorColor,
          width: 0,
          height: 0,
        },
      };
      return variantTypes[variant];
    };

    const boxedAssessmentStyle = () => {
      return variant === "boxed"
        ? {
            border: "1px solid #90949A",
          }
        : {};
    };
    const getVendorTabStyles = (index) => {
      // checking  in tabs[index] inovice_status is null then update the null value  to invoiceStatus value
      if (tabs[index]) {
        tabs[index].invoice_status =
          tabs[index]?.invoice_status === null
            ? tabs[index]?.invoiceStatus
            : tabs[index]?.invoice_status;
      }

      const { investigationStatus, invoice_status, activeTab, isActive } =
        tabs[index];

      let status =
        activeTab === ApprovalInvestigationMainTabs[1]?.label
          ? investigationStatus
          : activeTab === ApprovalInvestigationMainTabs[2]?.label
            ? invoice_status
            : activeTab === ApprovalInvestigationMainTabs[0]?.label
              ? investigationStatus
              : "pending";
      if (!isActive && activeTab !== ApprovalInvestigationMainTabs[2]?.label) {
        status = "rejected";
      }
      if (variant === "boxed") {
        status = investigationStatus;
      }

      const vendor = vendorTabStyles?.find((vendor) => {
        return vendor?.label === status;
      });

      const color = vendor?.color;
      const bgColor = vendor?.bgColor;
      const border =
        tabValue === index
          ? vendor?.border
          : status === "pending" || status === "review"
            ? " 1px solid #90949A"
            : "none";
      const boxShadow = tabValue === index ? vendor?.boxShadow : "";
      const padding = vendor?.padding;

      const tabStyles = {};
      if (color) {
        tabStyles.color = color;
      }
      if (bgColor) {
        tabStyles.backgroundColor = bgColor;
      }
      if (border) {
        tabStyles.border = border;
      }
      if (boxShadow) {
        tabStyles.boxShadow = boxShadow;
      }
      if (padding) {
        tabStyles.padding = padding;
      }

      return tabStyles;
    };
    const getCustomWidth = () => {
      if (customStyle) {
        return { minWidth: "72px" };
      } else {
        return null;
      }
    };
    // const getVendorInvestigationFirstTabStyle = (item, index) => {
    //   const investigationFirstTabStyle = investigationFirstTab.find(
    //     (tab) => tab.label === item.label
    //   );
    //   const isActiveTab = tabValue === index; // Check if the tab is active
    //   const border = isActiveTab
    //     ? investigationFirstTabStyle?.activeBorderColor || ""
    //     : investigationFirstTabStyle?.border || "";

    //   return { border }; // Merge the styles
    // };
    useEffect(() => {
      setTimeout(() => {
        tabRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }, 350);
    }, []);

    useEffect(() => {
      setTabValue(activeTab);
    }, [activeTab]);

    return (
      <Box sx={{ width: "100%" }} ref={ref}>
        <Box
          ref={tabRef}
          sx={{
            display: "flex",
            gap: "1.6rem",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="tabs-label"
            indicatorColor={indicatorColor}
            TabIndicatorProps={{
              style: getStyleTabIndicator(),
            }}
            variant={variant === "boxed" ? "standard" : "scrollable"}
            sx={{
              ...(variant === "boxed" || popupType === "manual"
                ? {
                    "& .MuiTabs-flexContainer": {
                      flexWrap: "wrap",
                    },
                  }
                : variant === "standard" && !standardMinContent
                  ? {
                      width: "100%",
                      "& .MuiTabs-flexContainer": {
                        justifyContent: "space-between",
                      },
                    }
                  : {}),
              "& .MuiTabs-scroller": {
                willChange: "transform",
                scrollBehavior: "smooth",
              },
            }}
            scrollButtons={false}
          >
            {(!tabs?.length ? Array(5)?.fill({ label: 0 }) : tabs)?.map(
              (item, index) => {
                return (
                  <Tab
                    id={index}
                    sx={{
                      ...getCustomWidth(),
                      border: 0,
                      padding:
                        popupType === "manual"
                          ? `0 0 12px 0`
                          : variant === "boxed"
                            ? "7px 5px"
                            : variant === "customStyleTab"
                              ? 0
                              : `12px ${gap} 12px 16px`,
                      cursor:
                        searchSource === "Cima" &&
                        disableSecondTabVal?.includes(item?.label) &&
                        searchValue &&
                        searchType
                          ? "not-allowed"
                          : "pointer",
                    }}
                    key={item?.label + index}
                    disableRipple
                    icon={item?.icon}
                    iconPosition="end"
                    data-invoice_status={item?.invoice_status}
                    data-investigation_status={item?.investigationStatus}
                    label={
                      <Typography
                        sx={{
                          width: popupType === "manual" ? "8.5rem" : "unset",
                          padding,
                          textAlign: "left",
                          fontFamily: "Inter",
                          ...getStyle(index, item),
                          ...(tabs[index]?.investigationStatus ||
                          tabs[index]?.invoice_status
                            ? getVendorTabStyles(index)
                            : ""),
                          ...boxedAssessmentStyle(),
                        }}
                        data-invoice_status={item?.invoice_status}
                        data-investigation_status={item?.investigationStatus}
                      >
                        {breakLabel
                          ? breakWordOnSpace(item?.label)
                          : item?.label || (
                              <Skeleton animation="wave" width="8.5rem" />
                            )}
                      </Typography>
                    }
                  ></Tab>
                );
              }
            )}
          </Tabs>
        </Box>
      </Box>
    );
  }
);

MuiTab.propTypes = {
  indicatorColor: propTypes.string,
  onClick: propTypes.func,
  tabs: propTypes.array,
  variant: propTypes.string,
  gap: propTypes.string,
  activeTab: propTypes.number,
  // customStyle: propTypes.object,
};

export default MuiTab;
